const getDefaultState = () => {
  return {
    deposits: null,
    activeDeposit: null
  }
}

const state = getDefaultState()

const getters = {
  deposits: (state) => state.deposits,
  activeDeposit: (state) => state.activeDeposit
};

const actions = {
  async getDeposits({ commit }) {
    try {
      const res = await fetch('deposits', {
        headers: { 'Accept': 'application/json' }
      })
      if (!res.ok) {
        throw new Error(`${res.status} ${res.statusText}`)
      }
      const data = await res.json()
      commit('setDeposits', data)
    } catch (err) {
      console.error('Failed to load deposits:', err)
    }
  },
  resetState ({ commit }) {
    commit('resetState')
  },
};

const mutations = {
  setDeposits(state, deposits) {
    state.deposits = deposits;
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
